module.exports = __webpack_public_path__ + "static/media/support.96e9d830.png";